import {resolveGenericContentCta, type GenericContent} from '../../../../../../brand/lib/types/contentful'
import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import {Text} from '@primer/react-brand/esm'
import {CtaButtons} from '../../_shared/CtaButtons/CtaButtons'
import {Eyebrow} from '../../_shared/Eyebrow/Eyebrow'
import {Spacer} from '../../_shared/Spacer/Spacer'

import Styles from './Overview.module.css'

type Props = {
  content: GenericContent
  list: GenericContent[]
  location: string
}

export function Overview(props: Props) {
  const {content, list, location} = props
  const {htmlId, label, text} = content.fields

  const direction = htmlId || 'left' // Used for setting left/right alignment

  const eyebrow = label?.fields.text
  const description = text ? documentToPlainTextString(text) : ''
  const ctaGroup = resolveGenericContentCta(content, {legacyFallback: 'first'})

  return (
    <div className={Styles.Overview} data-direction={direction}>
      <div className={Styles.Cell}>
        {eyebrow && <Eyebrow text={eyebrow} />}

        {list.length > 0 && (
          <>
            <Spacer size="64px" />
            <ul className={Styles.List}>
              {list.map(item => (
                <li key={item.sys.id} className={Styles.ListItem}>
                  {item.fields.heading}
                </li>
              ))}
            </ul>
          </>
        )}
      </div>

      <div className={Styles.Cell}>
        <div>
          {description && (
            <div>
              <Text as="p" className={Styles.Description}>
                {description}
              </Text>
            </div>
          )}

          {ctaGroup && (
            <>
              <Spacer size="32px" size1280="64px" />
              <div>
                <CtaButtons contentfulContent={ctaGroup} location={location} />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
